import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=753cc928&scoped=true&"
import script from "./instructions.vue?vue&type=script&lang=js&"
export * from "./instructions.vue?vue&type=script&lang=js&"
import style0 from "./instructions.vue?vue&type=style&index=0&id=753cc928&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753cc928",
  null
  
)

export default component.exports